import {ReactElement} from "react"
import {MenuItemProps} from "@ui/components/services/menu"
import Main from "./Main"

export type TLayerPageProps = {
	close: () => void
  isShow: boolean
}

const Layer  = (props: MenuItemProps): ReactElement => {
  return (
    <div className="layer">
      <Main {...props}/>
    </div>
  )
}

export default Layer
